const faqAccordionItemElements = document.getElementsByClassName("faq-item");

for (const faqAccordionItemElement of faqAccordionItemElements) {
  faqAccordionItemElement.onclick = function () {
    const faqItemContent =
      faqAccordionItemElement.querySelector(".faq-item-content");
    const faqItemIcon = faqAccordionItemElement.querySelector(".faq-item-icon");

    const isOpen = faqItemContent.style.display === "block";
    faqItemContent.style.display = isOpen ? "none" : "block";
    const bodyId = document.querySelector('body').id;
    faqItemIcon.src = (bodyId == 'holiday-promo' || bodyId == 'sunnies-picnic-sunnies-studios')
      ? (!isOpen
        ? "https://cdn.shopify.com/s/files/1/0172/4383/2374/files/minus_icon_softblack.svg?v=1761815807"
        : "https://cdn.shopify.com/s/files/1/0172/4383/2374/files/plus_icon_softblack.svg?v=1761815807")
      : (!isOpen
        ? "https://cdn.shopify.com/s/files/1/0172/4383/2374/files/Vector_1.svg?v=1665405625"
        : "https://cdn.shopify.com/s/files/1/0172/4383/2374/files/Vector_43ddc302-93b6-4847-bd71-abaff4585e9e.svg?v=1665404846");
  };
}

// Customize [check-icon]
// const faqContents = document.querySelectorAll(".faq-item-content");
// faqContents.forEach((faqContent)=>{
//   const content = faqContent.innerHTML;
//   const updatedContent = content.replace(/\[check-icon\]/g, "<img src='https://cdn.shopify.com/s/files/1/0172/4383/2374/files/icon_checked-circle.svg?v=1676482303'>");
//   faqContent.innerHTML = updatedContent;
// })